import { CircleNotch } from "@phosphor-icons/react";
import { clsx } from "clsx";
import { type ComponentProps, type ForwardedRef, forwardRef } from "react";

interface LoaderProps extends ComponentProps<"div"> {
  iconSize?: number;
}

function Loader(
  { iconSize = 80, className, ...props }: LoaderProps,
  ref: ForwardedRef<HTMLDivElement>,
) {
  return (
    <div
      ref={ref}
      className={clsx("flex grow items-center justify-center", className)}
      {...props}
    >
      <CircleNotch size={iconSize} className="animate-spin fill-black-300" />
    </div>
  );
}
Loader.displayName = "Loader";

export default forwardRef(Loader);
